export default "__VITE_ASSET__EZmfNvYZ__"